import React from 'react'
import PropTypes from 'prop-types'

import * as spotify from '../services/spotify'

const GENERATOR_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3001/dev'
    : 'https://036asudf3m.execute-api.us-east-1.amazonaws.com/dev'

class SaveProvider extends React.Component {
  state = {
    authorised: false,
    loading: false,
    playlistId: null,
    error: null
  }

  componentDidMount() {
    const token = spotify.getToken()
    if (token) {
      this.setState({ authorised: true })
    }
  }

  createPlaylist = () => {
    const { festivalId, beatswitchApiKey, useFestivalTools } = this.props

    this.setState({ loading: true, error: null })
    const token = spotify.getToken()

    fetch(`${GENERATOR_URL}/festival/${festivalId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        spotifyAccessToken: token,
        beatswitchApiKey,
        useFestivalTools,
      })
    })
      .then(r => r.json())
      .then(r => {
        if (r.error) {
          return this.setState({
            error: 'Something went wrong. Please try again later!'
          })
        }
        this.setState({
          loading: false,
          playlistId: r.playlistId,
          userId: r.userId
        })
      })
      .catch(() =>
        this.setState({
          error: 'Something went wrong. Please try again later!'
        })
      )
  }

  login = () => {
    const { spotifyClientId } = this.props
    spotify.login(spotifyClientId).then(() => {
      this.setState({ authorised: true })
      this.createPlaylist()
    })
  }

  render() {
    const { authorised, loading, playlistId, userId, error } = this.state
    const { children } = this.props

    return children({
      authorised,
      loading,
      playlistId,
      userId,
      error,
      login: this.login,
      createPlaylist: this.createPlaylist
    })
  }
}

SaveProvider.propTypes = {
  spotifyClientId: PropTypes.string.isRequired,
  festivalId: PropTypes.string.isRequired,
  beatswitchApiKey: PropTypes.string
}

export default SaveProvider



// WEBPACK FOOTER //
// ./src/components/SaveProvider.js